import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const MaterialHelpIcon = () => {
  return <HelpOutlineIcon htmlColor="#1A1A1A" />;
};

export default MaterialHelpIcon;
